import { css } from "lit";

export const styles = css`
  .crop-canvas {
    width: 100%;
    height: 500px;
    background: #f3f4f6;
    display: block;
    border-radius: 8px;
    margin: 0 auto;
    box-shadow: 0 1px 4px rgb(0 0 0 / 0.04);
    touch-action: none;
  }

  @media (max-width: 768px) {
    .crop-canvas {
      height: 100%;
    }
  }

  [slot="one-column"] {
    height: 100%;
  }
`;
